import { PHASE_BATTERY_ELECTRICALS } from '../../constants';

import type { BatteryTabKey } from './types';

export const TEST_ID = 'batteryDetailDrawer';

export const BATTERY_TABS = ['overview', 'firmware', 'electricals'] as const;

export const BATTERY_TAB_MIN_PHASE: Record<BatteryTabKey, number> = {
    electricals: PHASE_BATTERY_ELECTRICALS,
    firmware: 1,
    overview: 1
};
